/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Chemistry15Inputs */

const en__field__enum_studyprograms_study_chemistry15 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Chemistry15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemistry`)
};

const de__field__enum_studyprograms_study_chemistry15 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Chemistry15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemie`)
};

/**
* | output |
* | --- |
* | "Chemistry" |
*
* @param {_Field__Enum_Studyprograms_Study_Chemistry15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_chemistry15 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Chemistry15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Chemistry15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_chemistry15(inputs)
	return de__field__enum_studyprograms_study_chemistry15(inputs)
});
export { _field__enum_studyprograms_study_chemistry15 as "_field__enum_studyPrograms_STUDY_CHEMISTRY" }